var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPitCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 73.539,
    height: 73.539,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#707070",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.771 1.768L1.768 71.77M71.771 71.771L1.768 1.768"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPitCrossIcon);
export default __webpack_public_path__ + "static/media/pitCrossIcon.1ff93f233cafc16f.svg";
export { ForwardRef as ReactComponent };